import React from "react";
import { useHistory } from "react-router";
import { makeStyles } from "@material-ui/core";
import MeME from "../../../assets/icon/tomemeLogo.png";

const MeMETitle = () => {
  const { push } = useHistory();

  const useStyles = makeStyles((theme) => ({
    titleCenter: {
      "& h1": {
        textAlign: "center",
      },
    },
    MeMEIcon: {
      width: 200,
      margin: "50px 0",
      cursor: "pointer",
    },
    iconArea: {
      width: 200,
      margin: "0 auto",
    },
  }));

  const classes = useStyles();
  return (
    <div className={`${classes.titleCenter}`}>
      <div className={classes.iconArea} onClick={() => push("/")}>
        <img
          src={MeME}
          className={`${classes.MeMEIcon}`}
          alt="title"
          height={37}
          width={200}
        />
      </div>
    </div>
  );
};

export default React.memo(MeMETitle);
